export const LogoImg = ({ variant = "moss", className = "h-11 w-auto" }) => (
  <img
    src={variant === "white" ? "/greenlab-logo.png" : "/greenlab-logo-moss.png"}
    alt="GreenLab — Disinfestazione"
    className={className}
  />
);

export const Logo = () => (
  <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
    <LogoImg />
    <span className="leading-none">
      <span className="block text-xs sm:text-sm font-bold uppercase tracking-wide text-moss mt-1">
        Consulenza Dott. G. Vincenti
      </span>
    </span>
  </a>
);
